import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ProjectBookmarkButtonModule } from '../../app/projects/project-view/project-view-details/project-bookmark-button/project-bookmark-button.module';
import { DirectQuoteButtonModule } from '../../app/quotations/direct-quote-button/direct-quote-button.module';
import { AiModalModule } from './ai-modal/ai-modal.module';
import { AutoCompleteModule } from './auto-complete/auto-complete.module';
import { AutoLinkDirective } from './auto-link/auto-link.directive';
import {
  BidPatternCardActionsComponent,
  BidPatternCardActionsNotesComponent,
  BidPatternCardAdditionalDetailsComponent,
  BidPatternCardComponent,
} from './bid-pattern-card/bid-pattern-card.component';
import { ChallengeStatusTagComponent } from './challenge-status-tag/challenge-status-tag.component';
import { ChatButtonComponent } from './chat-button/chat-button.component';
import { ChatButtonModule } from './chat-button/chat-button.module';
import { CustomBannerComponent } from './custom-banner/custom-banner.component';
import { DynamicTextComponent } from './dynamic-text';
import { ExperienceDetailsPatternComponent } from './experience/experience-details-pattern.component';
import { ExperienceComponent } from './experience/experience.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { InteractiveTextComponent } from './interactive-text/interactive-text.component';
import { LinkshimModule } from './linkshim/linkshim.module';
import { MyListsModule } from './my-lists/my-lists.module';
import {
  NewsfeedSystemMessagesBodyContentComponent,
  NewsfeedSystemMessagesBodyCopyComponent,
  NewsfeedSystemMessagesComponent,
  NewsfeedSystemMessagesFooterActionLeftComponent,
  NewsfeedSystemMessagesFooterActionMiddleComponent,
  NewsfeedSystemMessagesFooterActionRightComponent,
  NewsfeedSystemMessagesHeaderCopyEndComponent,
  NewsfeedSystemMessagesHeaderCopyStartComponent,
  NewsfeedSystemMessagesHedaderLinkComponent,
} from './newsfeed-system-messages';
import { ProjectContestCardTagsComponent } from './project-contest-card/project-contest-card-tags/project-contest-card-tags.component';
import { ProjectContestCardComponent } from './project-contest-card/project-contest-card.component';
import { RadioCardComponent } from './radio-card/radio-card.component';
import {
  ReviewCardComponent,
  ReviewCardReplyComponent,
  ReviewCardServicesComponent,
} from './review-card/review-card.component';
import {
  ServiceOfferingCarouselCardComponent,
  ServiceOfferingCarouselComponent,
  ServiceOfferingCarouselHeaderComponent,
  ServiceOfferingCarouselHeaderDisplayComponent,
  ServiceOfferingCarouselHeaderEditComponent,
} from './service-offering-carousel';
import {
  ShowcaseCardHoverActionComponent,
  ShowcaseCardHoverContentComponent,
} from './showcase-card/showcase-card-hover-content.component';
import { ShowcaseCardPriceComponent } from './showcase-card/showcase-card-price.component';
import {
  ShowcaseCardCarouselItemComponent,
  ShowcaseCardComponent,
  ShowcaseCardDescriptionComponent,
  ShowcaseCardExpandableContentComponent,
  ShowcaseCardTitleComponent,
} from './showcase-card/showcase-card.component';
import { ShowcaseLikesComponent } from './showcase-card/showcase-likes.component';
import { ShowcaseThumbnailComponent } from './showcase-thumbnail/showcase-thumbnail.component';
import { SkillsModule } from './skills/skills.module';
import { TasklistsModule } from './tasklists/tasklists.module';
import { UpgradeItemComponent } from './upgrade-item/upgrade-item.component';
import { UserFeedbackModule } from './user-feedback/user-feedback.module';
import {
  UserInfoComponent,
  UserInfoMyListComponent,
} from './user-info/user-info.component';
import { UserRehireCardComponent } from './user-rehire-card';
import { UserSearchCardLoadingComponent } from './user-search-card/user-search-card-loading/user-search-card-loading.component';
import {
  UserSearchCardActionComponent,
  UserSearchCardComponent,
} from './user-search-card/user-search-card.component';

@NgModule({
  imports: [
    AiModalModule,
    AutoCompleteModule,
    AutoLinkDirective,
    ChallengeStatusTagComponent,
    ChatButtonModule,
    CommonModule,
    DirectQuoteButtonModule,
    DynamicTextComponent,
    FeatureFlagsModule,
    LinkshimModule,
    MatTooltipModule,
    MyListsModule,
    PipesModule,
    ProjectBookmarkButtonModule,
    SkillsModule,
    TasklistsModule,
    TrackingModule,
    UiModule,
    UserFeedbackModule,
  ],
  declarations: [
    BidPatternCardComponent,
    BidPatternCardAdditionalDetailsComponent,
    BidPatternCardActionsComponent,
    BidPatternCardActionsNotesComponent,
    CustomBannerComponent,
    ExperienceComponent,
    ExperienceDetailsPatternComponent,
    FileUploadComponent,
    InteractiveTextComponent,
    NewsfeedSystemMessagesComponent,
    NewsfeedSystemMessagesBodyCopyComponent,
    NewsfeedSystemMessagesHeaderCopyEndComponent,
    NewsfeedSystemMessagesHedaderLinkComponent,
    NewsfeedSystemMessagesHeaderCopyStartComponent,
    NewsfeedSystemMessagesBodyContentComponent,
    NewsfeedSystemMessagesFooterActionLeftComponent,
    NewsfeedSystemMessagesFooterActionMiddleComponent,
    NewsfeedSystemMessagesFooterActionRightComponent,
    ProjectContestCardComponent,
    ProjectContestCardTagsComponent,
    RadioCardComponent,
    ReviewCardComponent,
    ReviewCardServicesComponent,
    ReviewCardReplyComponent,
    ServiceOfferingCarouselComponent,
    ServiceOfferingCarouselCardComponent,
    ServiceOfferingCarouselHeaderComponent,
    ServiceOfferingCarouselHeaderDisplayComponent,
    ServiceOfferingCarouselHeaderEditComponent,
    ShowcaseCardComponent,
    ShowcaseCardDescriptionComponent,
    ShowcaseCardHoverActionComponent,
    ShowcaseCardHoverContentComponent,
    ShowcaseCardPriceComponent,
    ShowcaseCardTitleComponent,
    ShowcaseCardExpandableContentComponent,
    ShowcaseCardCarouselItemComponent,
    ShowcaseLikesComponent,
    ShowcaseThumbnailComponent,
    UpgradeItemComponent,
    UserInfoComponent,
    UserInfoMyListComponent,
    UserRehireCardComponent,
    UserSearchCardActionComponent,
    UserSearchCardComponent,
    UserSearchCardLoadingComponent,
  ],
  exports: [
    AiModalModule,
    AutoCompleteModule,
    AutoLinkDirective,
    BidPatternCardComponent,
    BidPatternCardAdditionalDetailsComponent,
    BidPatternCardActionsComponent,
    BidPatternCardActionsNotesComponent,
    ChallengeStatusTagComponent,
    ChatButtonComponent,
    CustomBannerComponent,
    DynamicTextComponent,
    ExperienceComponent,
    ExperienceDetailsPatternComponent,
    FileUploadComponent,
    InteractiveTextComponent,
    LinkshimModule,
    MyListsModule,
    NewsfeedSystemMessagesComponent,
    NewsfeedSystemMessagesBodyCopyComponent,
    NewsfeedSystemMessagesHeaderCopyEndComponent,
    NewsfeedSystemMessagesHedaderLinkComponent,
    NewsfeedSystemMessagesHeaderCopyStartComponent,
    NewsfeedSystemMessagesBodyContentComponent,
    NewsfeedSystemMessagesFooterActionLeftComponent,
    NewsfeedSystemMessagesFooterActionMiddleComponent,
    NewsfeedSystemMessagesFooterActionRightComponent,
    ProjectContestCardComponent,
    RadioCardComponent,
    SkillsModule,
    ReviewCardComponent,
    ReviewCardServicesComponent,
    ReviewCardReplyComponent,
    ServiceOfferingCarouselComponent,
    ServiceOfferingCarouselCardComponent,
    ServiceOfferingCarouselHeaderComponent,
    ShowcaseCardComponent,
    ShowcaseCardDescriptionComponent,
    ShowcaseCardHoverActionComponent,
    ShowcaseCardHoverContentComponent,
    ShowcaseCardPriceComponent,
    ShowcaseCardTitleComponent,
    ShowcaseCardExpandableContentComponent,
    ShowcaseCardCarouselItemComponent,
    ShowcaseLikesComponent,
    ShowcaseThumbnailComponent,
    TasklistsModule,
    UpgradeItemComponent,
    UserInfoComponent,
    UserInfoMyListComponent,
    UserRehireCardComponent,
    UserSearchCardActionComponent,
    UserSearchCardComponent,
    UserSearchCardLoadingComponent,
  ],
})
export class ComponentsModule {}
